import { Component, OnInit } from '@angular/core';
import { TestimonyService } from '../testimony/testimony.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    testimonies: any[] = [];

  constructor(private testimonyService: TestimonyService) { }

 
   ngOnInit(): void {
       this.loadTestimonies();;
     }
     loadTestimonies(): void {
    this.testimonyService.getTestimonies().subscribe({
      next: (data) => {
        this.testimonies = data;
         console.log( this.testimonies);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

}
